export default [
  {
    name: 'Category',
    prop: 'category_id',
    type: 'autocomplete',
    references: 'admin/categories',
    customFilters: { type: 'product' },
    referenceProp: 'name'
  },
  {
    name: 'Discount',
    prop: 'discount_id',
    type: 'autocomplete',
    references: 'admin/discounts',
    referenceProp: 'code'
  }
]
